<template>
  <li
    @click="
      data.click !== null && data.click !== undefined
        ? redirectToPage(data.click)
        : redirectToPage('Default')
    "
  >
    <a
      :target="data.target"
      :href="
        data.hrefLink !== null && data.hrefLink !== undefined
          ? data.hrefLink
          : '#'
      "
      >{{ data.title !== null && data.title !== undefined ? data.title : "Link"
      }}<q-icon
name="navigate_next"
    /></a>
  </li>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      required: true,
      default: null
    }
  },
  methods: {
    redirectToPage (d) {
      this.$router.push({
        name: d
      });
    }
  }
};
</script>

<style lang="scss" scoped>
li {
  a {
    cursor: pointer;
    text-decoration: none;
    color: inherit;
  }
}
</style>
